<script>
import { api } from "@/state/services";

// Ids de status de ticket (Model_tickets): 13 = Aguardando informação, 15 = Encerrada
const STATUS_WAITING = 13;
const STATUS_CLOSED = 15;

// Atendimento: solicitações abertas e alerta de "Aguardando informação"
export default {
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
    };
  },
  computed: {
    opened() {
      return this.list.filter((row) => row.ticket_status && row.ticket_status.id != STATUS_CLOSED);
    },
    waiting() {
      return this.list.filter((row) => row.ticket_status && row.ticket_status.id == STATUS_WAITING);
    },
  },
  mounted() {
    api
      .get("ticket")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          this.list = response.data.list || [];
        }
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="font-size-15 mb-0">Atendimento</h5>
        <router-link to="/contact" class="font-size-13">Ver solicitações</router-link>
      </div>
      <b-skeleton v-if="loading" width="60%"></b-skeleton>
      <p v-else-if="errored" class="text-muted mb-0">Não foi possível carregar o atendimento agora.</p>
      <template v-else>
        <router-link
          v-if="waiting.length > 0"
          :to="waiting.length == 1 ? '/contact/' + waiting[0].id : '/contact'"
          class="alert alert-warning d-block mb-2 p-2"
        >
          <i class="bx bx-error-circle align-middle mr-1"></i>
          {{ waiting.length == 1 ? "1 solicitação aguardando sua informação" : waiting.length + " solicitações aguardando sua informação" }}
        </router-link>
        <p class="mb-0">
          <template v-if="opened.length > 0">
            <strong>{{ opened.length }}</strong> {{ opened.length == 1 ? "solicitação aberta" : "solicitações abertas" }}
          </template>
          <span v-else class="text-muted">Nenhuma solicitação aberta.</span>
        </p>
      </template>
    </div>
  </div>
</template>
